import formMixin from '../../../mixins/formMixin'

export default {
    name: 'FormTextarea',

    mixins: [formMixin]
}
